/* eslint-disable global-require */
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
/* COMPOENT */
import { useReactiveVar } from '@apollo/client';
import { selectedPeriodVar } from 'app/apollo/reaction';
import { isDateInRange } from 'app/containers/contexts/filters.context/filters.context';
import { useParticipantIdABTest } from 'app/views/Menu/Menu/hooks/useParticipantIdABTest';
import { isDesktop } from 'app/utils/resolution';
import { AbstractDishShield } from './img/Shield';
import { AbstractDishShieldV2 } from './imgV2/Shield';

/* STYLES */
import s from './dish-image-shield.scss';

const dishWithShield = new Map([
    [
        '4607',
        [{
            name: 'abrau', type: 'combined', isShownOnLangings: true,
        }],
    ],
    [
        '5537',
        [{
            name: 'abrau', type: 'combined', isShownOnLangings: true,
        }],
    ],
    // [
    //     '4956',
    //     [{
    //         name: 'cabbage', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '4952',
    //     [{
    //         name: 'cabbage', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '3144',
    //     [{
    //         name: 'cabbage', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5474',
    //     [{
    //         name: 'nectarine', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '4109',
    //     [{
    //         name: 'nectarine', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5448',
    //     [{
    //         name: 'green', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '852',
    //     [{
    //         name: 'green', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5073',
    //     [{
    //         name: 'pepper', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '738',
    //     [{
    //         name: 'dacha', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],

    // [
    //     '5464',
    //     [{
    //         name: 'dacha', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5486',
    //     [{
    //         name: 'dacha', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5438',
    //     [{
    //         name: 'dacha', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5464',
    //     [{
    //         name: 'dacha', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5486',
    //     [{
    //         name: 'dacha', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5468',
    //     [{
    //         name: 'dacha', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5490',
    //     [{
    //         name: 'dacha', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5442',
    //     [{
    //         name: 'apricot', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5485',
    //     [{
    //         name: 'zucchini', type: 'text', periods: ['2026-08-10', '2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '1657',
    //     [{
    //         name: 'pear', type: 'text', periods: ['2026-08-17', '2026-08-24', '2026-08-31'], isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5300',
    //     [{
    //         name: 'odyssey', type: 'text', isShownOnLangings: true,
    //     }],
    // ],

    // [
    //     '5460',
    //     [{
    //         name: 'odyssey', type: 'text', isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5457',
    //     [{
    //         name: 'odyssey', type: 'text', isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '5455',
    //     [{
    //         name: 'odyssey', type: 'text', isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '4150',
    //     [{
    //         name: 'odyssey', type: 'text', isShownOnLangings: true,
    //     }],
    // ],
    // [
    //     '4402',
    //     [{
    //         name: 'odyssey', type: 'text', isShownOnLangings: true,
    //     }],
    // ],
]);


export const DishImageShield = ({
    dishId,
    isSoldOut = false,
    realm = false,
    tagsString = '',
}) => {
    const period = useReactiveVar(selectedPeriodVar);

    const shields = useMemo(() => {
        const currentShields = dishWithShield.get(dishId) || [];

        if (isSoldOut) {
            dishWithShield.set(dishId, [
                ...currentShields,
                { name: 'soldout', type: 'text', isShownOnLangings: true },
            ]);
        } else {
            dishWithShield.set(
                dishId,
                currentShields.filter((s) => s.name !== 'soldout'),
            );
        }

        // if (tagsString && !isSoldOut) {
        //     const isFastShield = tagsString.includes('2121');
        //     if (isFastShield) {
        //         return [{ name: 'fast', type: 'text', isShownOnLangings: false }];
        //     }
        // }

        return dishWithShield.get(dishId) || [];
    }, [dishId, isSoldOut]);

    const currentShield = shields.find((s) => s?.name === 'soldout')
        || (shields).find((s) => Array.isArray(s?.periods) && s.periods.some((p) => isDateInRange(p, period, 1)))
        || shields[0]
        || {};

    const {
        name = '',
        type = '',
        isShownOnLangings = false,
        lpOnly = false,
    } = currentShield;


    if (!name || !type) return null;

    if (realm === 'lp' && !isShownOnLangings) return null;
    if (realm !== 'lp' && lpOnly) return null;

    return (
        <div className={s['dish-image-shield__root']}>
            {!isDesktop()
                ? <AbstractDishShieldV2 name={name} type={type} />
                : <AbstractDishShield name={name} type={type} />
            }
        </div>
    );
};


DishImageShield.propTypes = {
    dishId: PropTypes.string.isRequired,
    isSoldOut: PropTypes.bool,
    realm: PropTypes.string,
};

/* DEPRECATED */

// ['4046', [{ name: 'biomio', type: 'text', isShownOnLangings: true }]],
// ['3518', [{ name: 'biomio', type: 'text', isShownOnLangings: true }]],
// ['5360',
//     [
//         { name: 'biomio', type: 'text', periods: ['2026-05-11'] },
//     ],
// ],
// ['5363',
//     [
//         { name: 'biomio', type: 'text', periods: ['2026-05-18'] },
//     ],
// ],
// ['5219', [{ name: 'biomio', type: 'text', isShownOnLangings: true }]],
// ['4873', [{ name: 'biomio', type: 'text', isShownOnLangings: true }]],
// ['5381', [{ name: 'biomio', type: 'text', isShownOnLangings: true }]],

// ['3784', [{ name: 'monica', type: 'combined', isShownOnLangings: true }]],
// ['3791', [{ name: 'theory', type: 'combined', isShownOnLangings: true }]],
// ['3789', [{ name: 'avengers', type: 'combined', isShownOnLangings: true }]],
// ['3790', [{ name: 'pulp', type: 'combined', isShownOnLangings: true }]],
// ['3782', [{ name: 'ameli', type: 'combined', isShownOnLangings: true }]],
// ['4640', [{ name: 'peaks', type: 'combined', isShownOnLangings: true }]],
// ['4178', [{ name: 'housewives', type: 'combined', isShownOnLangings: true }]],
// ['3865', [{ name: 'twilight', type: 'combined', isShownOnLangings: true }]],
// ['4644', [{ name: 'moon', type: 'combined', isShownOnLangings: true }]],
// ['4645', [{ name: 'cards', type: 'combined', isShownOnLangings: true }]],
// ['5125', [{ name: 'shrek', type: 'combined', isShownOnLangings: true }]],
// ['5104', [{ name: 'shrimps', type: 'combined', isShownOnLangings: true }]],
// ['4168', [{ name: 'lasso', type: 'combined', isShownOnLangings: true }]],

// ['4574', [{ name: 'olya', type: 'combined' }]],
// ['4581', [{ name: 'olya', type: 'combined' }]],
// ['4556', [{ name: 'olya', type: 'combined' }]],
// ['4557', [{ name: 'olya', type: 'combined' }]],
// ['4575', [{ name: 'olya', type: 'combined' }]],

// ['4495', [{ name: 'fennel', type: 'text' }]],
// ['4515', [{ name: 'kohlrabi', type: 'text' }]],
// ['4498', [{ name: 'mongold', type: 'text' }]],
// ['4510', [{ name: 'bokchoy', type: 'text' }]],
// ['4455', [{ name: 'wildgarlic', type: 'text' }]],

// ['1046', [{ name: 'baklajan', type: 'text' }]],
// ['1776', [{ name: 'corn', type: 'text' }]],
// ['4608', [{ name: 'lisichki', type: 'text' }]],
// ['4109', [{ name: 'nectarine', type: 'text' }]],
// ['1012', [{ name: 'paprika', type: 'text' }]],

// ['1866', [{ name: 'dacha', type: 'text' }]],
// ['3739', [{ name: 'dacha', type: 'text' }]],
// ['4592', [{ name: 'dacha', type: 'text' }]],

// ['4875',
//     [
//         { name: 'teacher', type: 'text', periods: ['2025-09-29'] },
//         { name: 'relax-gift', type: 'text', periods: ['2025-10-06'] },
//         { name: 'relax-gift', type: 'text', periods: ['2025-10-13'] },
//         { name: 'relax-gift', type: 'text', periods: ['2025-10-20'] },
//     ],
// ],

// ['4689', [{ name: 'halloween', type: 'visual' }]],
// ['4688', [{ name: 'halloween', type: 'visual' }]],
// ['4693', [{ name: 'halloween', type: 'visual' }]],
// ['3828', [{ name: 'halloween', type: 'visual' }]],
// ['4695', [{ name: 'halloween', type: 'visual' }]],


// ['1257',
//     [{
//         name: 'favorite',
//         type: 'upperText',
//         isShownOnLangings: true,
//         lpOnly: true,
//     }],
// ],
// ['3837',
//     [{
//         name: 'favorite',
//         type: 'upperText',
//         isShownOnLangings: true,
//         lpOnly: true,
//     }],
// ],
// ['3838',
//     [{
//         name: 'twentyminutes',
//         type: 'upperText',
//         isShownOnLangings: true,
//         lpOnly: true,
//     }],
// ],
// ['3839',
//     [{
//         name: 'sale',
//         type: 'upperText',
//         isShownOnLangings: true,
//         lpOnly: true,
//     }],
// ],

// ['5153',
//     [{
//         name: 'sale',
//         type: 'upperText',
//         isShownOnLangings: true,
//         lpOnly: true,
//     }],
// ],
// ['5152',
//     [{
//         name: 'new',
//         type: 'upperText',
//         isShownOnLangings: true,
//         lpOnly: true,
//     }],
// ],
// ['5157',
//     [{
//         name: 'new',
//         type: 'upperText',
//         isShownOnLangings: true,
//         lpOnly: true,
//     }],
// ],
// ['5159',
//     [{
//         name: 'new',
//         type: 'upperText',
//         isShownOnLangings: true,
//         lpOnly: true,
//     }],
// ],

// ['4371',
//     [{
//         name: 'tefal',
//         type: 'text',
//         isShownOnLangings: true,
//         lpOnly: false,
//         periods: ['2026-02-16'],
//     }],
// ],

// ['4344', [{ name: '_helena', type: 'text', isShownOnLangings: true }]],
// ['4011', [{ name: '_gertruda', type: 'text', isShownOnLangings: true }]],
// ['3941', [{ name: '_frida', type: 'text', isShownOnLangings: true }]],
// ['3948', [{ name: '_chanel', type: 'text', isShownOnLangings: true }]],
// ['3943', [{ name: '_carolina', type: 'text', isShownOnLangings: true }]],
// ['3945', [{ name: '_agata', type: 'text', isShownOnLangings: true }]],
// ['3942', [{ name: '_curie', type: 'text', isShownOnLangings: true }]],
// ['3947', [{ name: '_clara', type: 'text', isShownOnLangings: true }]],

// ['5284', [{ name: '_tsvetaeva', type: 'text', isShownOnLangings: true }]],
// ['5287', [{ name: '_lamarr', type: 'text', isShownOnLangings: true }]],
// ['5286', [{ name: '_emily', type: 'text', isShownOnLangings: true }]],

// ['1815', [{ name: 'paprika', type: 'text' }]],
// ['4590', [{ name: 'zucchini', type: 'text' }]],
// ['4303', [{ name: 'dacha', type: 'text' }]],
// ['4028', [{ name: 'kabachok', type: 'text' }]],
// ['4609', [{ name: 'broccoli', type: 'text' }]],
// ['3254', [{ name: 'baklajan', type: 'text' }]],
// ['2960',
//     [{
//         name: 'maslenytsa',
//         type: 'text',
//         isShownOnLangings: false,
//         lpOnly: false,
//         periods: ['2026-02-16'],
//     }],
// ],
// ['2166',
//     [{
//         name: 'maslenytsa',
//         type: 'text',
//         isShownOnLangings: false,
//         lpOnly: false,
//         periods: ['2026-02-16'],
//     }],
// ],
// ['431',
//     [{
//         name: 'maslenytsa',
//         type: 'text',
//         isShownOnLangings: false,
//         lpOnly: false,
//         periods: ['2026-02-16'],
//     }],
// ],

// Ahmad

// ['3677', { name: 'ahmad', type: 'combined' }],
// ['3833', { name: 'ahmad', type: 'combined' }],

// Kozel

// ['4663', { name: 'kozel', type: 'upper', isShownOnLangings: false }],
// ['4662', { name: 'kozel', type: 'upper', isShownOnLangings: false }],
// ['4664', { name: 'kozel', type: 'upper', isShownOnLangings: false }],
// ['4658', { name: 'kozel', type: 'upper', isShownOnLangings: false }],

// // submarine
// ['280', { name: 'submarine', type: 'text' }],
// ['679', { name: 'submarine', type: 'text' }],
// ['765', { name: 'submarine', type: 'text' }],
// ['764', { name: 'submarine', type: 'text' }],
// ['13', { name: 'submarine', type: 'text' }],
// ['2862', { name: 'submarine', type: 'text' }],
// ['3632', { name: 'submarine', type: 'text' }],
// ['4617', { name: 'submarine', type: 'text' }],
// ['1042', { name: 'submarine', type: 'text' }],
// ['2971', { name: 'submarine', type: 'text' }],
// ['3248', { name: 'submarine', type: 'text' }],
// ['3640', { name: 'submarine', type: 'text' }],
// ['4556', { name: 'submarine', type: 'text' }],
// ['4960', { name: 'submarine', type: 'text' }],

// miragosha

// ['3993', { name: 'miragosha', type: 'combined', isShownOnLangings: false }],
// ['4417', { name: 'miragosha', type: 'combined', isShownOnLangings: false }],

// yapracticum

// ['24', { name: 'yapracticum', type: 'combined', isShownOnLangings: false }],
// ['25', { name: 'yapracticum', type: 'combined', isShownOnLangings: false }],
// ['32', { name: 'yapracticum', type: 'combined', isShownOnLangings: false }],
// ['228', { name: 'yapracticum', type: 'combined', isShownOnLangings: false }],
// ['2929', { name: 'yapracticum', type: 'combined', isShownOnLangings: false }],
// ['4187', { name: 'yapracticum', type: 'combined', isShownOnLangings: false }],
// ['4779', { name: 'yapracticum', type: 'combined', isShownOnLangings: false }],
// ['2677', { name: 'yapracticum', type: 'combined', isShownOnLangings: false }],
// ['4236', { name: 'yapracticum', type: 'combined', isShownOnLangings: false }],
// ['4682', { name: 'yapracticum', type: 'combined', isShownOnLangings: false }],
